import { connect } from 'react-redux';
import { selectFooterLayout } from "../../store/slices/layout/selector";
import { selectSubscriptionBlock } from "../../store/selectors";
var mapStateToProps = function mapStateToProps(state) {
  var subscriptionBlock = selectSubscriptionBlock(state);
  var theme = selectFooterLayout(state);
  return {
    thankYou: subscriptionBlock.texts.thankYou,
    subscribe: subscriptionBlock.texts.subscribe,
    formIcon: subscriptionBlock.formIcon,
    theme: theme
  };
};
export var connector = connect(mapStateToProps);